<template>
  <div class="highlighter-wrapper relative d-flex flex-grow-1 flex-wrap">
    <document-viewer
      v-if="!documentHighlighter.isLoading"
      :document="document"
      :rotation="rotation"
      :overlays="documentHighlights"
      :show-page-check-signals="false"
      @rotate="$emit('rotate')"
    />
    <div v-else class="d-flex w-100 align-items-center justify-content-center">
      <i-spinner></i-spinner>
    </div>
  </div>
</template>

<script>
import DocumentViewer from './DocumentViewer';
import { iSpinner } from '@inscribe/signal';

export default {
  components: {
    'document-viewer': DocumentViewer,
    iSpinner,
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
    rotation: {
      type: Number,
      required: true,
    },
  },
  computed: {
    documentHighlighter() {
      return this.$store.state.documentHighlighter;
    },
    documentHighlights() {
      if (this.documentHighlighter.isLoading) {
        return [];
      }

      return this.documentHighlighter.documents[this.document.id];
    },
  },
  created() {
    this.getDocumentHighlighterBoundingBoxes();
  },
  methods: {
    getDocumentHighlighterBoundingBoxes() {
      this.$store.commit('setHighlighterLoading', true);
      this.$store
        .dispatch('getHighlighterBoundingBoxes', {
          customerId: this.document.customer_id,
          documentId: this.document.id,
        })
        .then(() => {
          this.$store.commit('setHighlighterLoading', false);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.highlighter-wrapper {
  max-height: 100%;
  overflow: auto;
}
</style>
